import React, { Component } from "react";
import styled from "styled-components";

import AS from "../Login/Service/Authentication";
import CS from "../../commons/services/Common";
import VS from "../../commons/services/Validation";

import PageTitle from "../../commons/components/PageTitle";
import Modal from "../../commons/components/Modal";
import InputErrorMsgWrapper from "../../commons/components/input/InputErrorWrap";
import { ROUTES } from "../../commons/constants/routes/routes";

class SiteManagerCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isWarningShow: false,
      validationErrors: {},
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  validateForm(data) {
    const validationErrors = {};

    if (!data.get("user_name")) {
      validationErrors.user_name = "담당자명을 입력해주세요.";
    }
    if (!data.get("phone")) {
      validationErrors.phone = "전화번호를 입력해주세요.";
    }
    if (!data.get("email")) {
      validationErrors.email = "이메일을 입력해주세요.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.get("email"))) {
      validationErrors.email = "올바른 이메일 형식이 아닙니다.";
    }
    if (!data.get("password")) {
      validationErrors.password = "패스워드를 입력해주세요.";
    }
    if (data.get("password") !== data.get("password_confirm")) {
      validationErrors.password_confirm = "패스워드가 일치하지 않습니다.";
    }

    if (Object.keys(validationErrors).length > 0) {
      this.setState({ validationErrors });
      return false;
    }
    return true;
  }

  async handleSubmit(e) {
    e.preventDefault();
    const data = new FormData(e.target);

    if (!this.validateForm(data)) return;

    const item = {

      userId: data.get("phone").replace(/[^0-9]/g, ""),
      userName: data.get("user_name"),
      userType: "USR_S",
      password: data.get("password"),
      mobileCarrier: "", //data.get('mobileCarrier'),
      phone: data.get("phone"),
      email: data.get("email"),
      organization: data.get("organization"),
      enabled: true,
      authorities: ["ROLE_SITE"],
      user: {
        nickName: data.get("user_name"),
      }

    };

    const result = await CS.create("/api/account", item);
    if (result.isSuccess) {
      this.props.history.push(ROUTES.SITE_MANAGER.MAIN);
    }
  }

  closeModal = () => {
    this.setState({ isWarningShow: false });
  };

  render() {
    const { validationErrors } = this.state;

    return (
      <>
        <PageTitle title="현장담당자 관리" location="현장담당자 등록" />
        <FormWrapper onSubmit={this.handleSubmit}>
          <FormContainer>
            <FormBox>
              <FormHead required>담당자명</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.user_name}
                  message={validationErrors.user_name}
                >
                  <input
                    type="text"
                    name="user_name"
                    className="comm-inp"
                    placeholder="담당자명을 입력하세요"
                    onChange={(e) => {
                      const { validationErrors } = this.state;
                      delete validationErrors.user_name;
                      this.setState({ validationErrors });
                      VS.characterCheck(e);
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead required>전화번호</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.phone}
                  message={validationErrors.phone}
                >
                  <input
                    type="text"
                    name="phone"
                    className="comm-inp"
                    placeholder="전화번호를 입력하세요"
                    onChange={(e) => {
                      const { validationErrors } = this.state;
                      delete validationErrors.phone;
                      this.setState({ validationErrors });
                      VS.onInput("phone", e);
                    }}
                  />
                </InputErrorMsgWrapper>
                <FieldHint>로그인 ID</FieldHint>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead required>이메일</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.email}
                  message={validationErrors.email}
                >
                  <input
                    type="text"
                    name="email"
                    className="comm-inp"
                    placeholder="이메일을 입력하세요"
                    onChange={() => {
                      const { validationErrors } = this.state;
                      delete validationErrors.email;
                      this.setState({ validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead>소속</FormHead>
              <FormBody>
                <input
                  type="text"
                  name="organization"
                  className="comm-inp"
                  placeholder="소속을 입력하세요"
                />
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead required>패스워드</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.password}
                  message={validationErrors.password}
                >
                  <input
                    type="password"
                    name="password"
                    className="comm-inp"
                    placeholder="패스워드를 입력하세요"
                    onChange={() => {
                      const { validationErrors } = this.state;
                      delete validationErrors.password;
                      delete validationErrors.password_confirm;
                      this.setState({ validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead required>패스워드 확인</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.password_confirm}
                  message={validationErrors.password_confirm}
                >
                  <input
                    type="password"
                    name="password_confirm"
                    className="comm-inp"
                    placeholder="패스워드를 다시 입력하세요"
                    onChange={() => {
                      const { validationErrors } = this.state;
                      delete validationErrors.password_confirm;
                      this.setState({ validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>
          </FormContainer>

          <BtnGroup>
            <button
              type="button"
              onClick={() => this.props.history.push(ROUTES.SITE_MANAGER.MAIN)}
            >
              취소
            </button>
            <button type="submit">저장</button>
          </BtnGroup>
        </FormWrapper>

        {this.state.isWarningShow && (
          <Modal
            icon={true}
            title="알림"
            text="저장 중 오류가 발생했습니다."
            btnGroup={false}
            closeModal={this.closeModal}
          />
        )}
      </>
    );
  }
}

const FormWrapper = styled.form`
  width: 1176px;
  margin: 55px auto 120px;
`;
const FormContainer = styled.div`
  max-width: 1176px;
  width: 100%;
  margin: 55px auto 20px;
  border: 1px solid #4b515b;
  border-width: 1px 0 1px;
`;
const FormBox = styled.div`
  padding: 14px 0;
  border-bottom: 1px solid #e3e5e7;
`;
const FormHead = styled.p`
  width: 140px;
  display: inline-block;
  font-size: 16px;
  color: #191919;
  font-weight: 600;
  padding-left: 12px;
  ${({ required }) =>
    required &&
    `&::after {
      content: " *";
      color: #FF5353;
    }`}
`;
const FormBody = styled.div`
  display: inline-block;
  input,
  select {
    border-radius: 4px;
  }
  .comm-inp {
    width: 436px;
  }
`;
const FieldHint = styled.span`
  display: inline-block;
  margin-left: 10px;
  font-size: 13px;
  color: #888e98;
  vertical-align: middle;
`;
const BtnGroup = styled.div`
  max-width: 1176px;
  width: 100%;
  text-align: right;
  margin: 0 auto;
  button {
    width: 120px;
    font-size: 14px;
    padding: 10px 0;
    text-align: center;
    border-radius: 5px;
    font-weight: 600;
    &:first-child {
      color: var(--secondary-500);
      background-color: transparent;
      border: 1px solid var(--secondary-500);
    }
    &:last-child {
      margin-left: 12px;
      color: var(--grey-900);
      background-color: var(--primary-500);
      border: 1px solid var(--primary-500);
    }
  }
`;

export default SiteManagerCreate;
